import dateFormatter from './date'
import numberFormatter from './number'

export default {
  ...numberFormatter,
  ...dateFormatter,
}
